import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

interface Props {
  action: () => void;
  buttonDisabled: boolean;
  buttonColor: "primary" | "error";
  variant?: "outlined";
}

const Confirmation: React.FC<Props> = ({
  children,
  action,
  buttonDisabled,
  buttonColor,
  variant,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant={variant}
        onClick={handleClickOpen}
        disabled={buttonDisabled}
        color={buttonColor}
      >
        {children}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Möchtest du wirklich ${children}?`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Möchtest du wirklich ${children}?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Abbrechen</Button>
          <Button
            onClick={() => {
              action();
              handleClose();
            }}
            autoFocus
          >
            Bestätigen
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Confirmation;
